<template>
  <div id="knowledge-base-article">
    <b-row>
      <!-- related question -->
      <b-col lg="3" md="5" order="2" order-md="1">
        <b-card>
          <h6 class="kb-title">
            <feather-icon class="mr-50" icon="InfoIcon" size="20"/>
            Nội dung liên quan
          </h6>
          <b-list-group class="list-group-circle mt-1">
            <b-list-group-item
                v-for="(que, index) in dataNews"
                :key="index"
                :to="{
                path: `/news/category/topics/${que.ID}`,
              }"
                class="text-body"
                href="javascript:void(0"
                @click="() => onChoseQuestion(que)"
            >
              {{ que.Title }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <!--/ related question -->

      <b-col lg="9" md="7" order="1" order-md="2">
        <b-card>
          <!-- Title -->
          <b-card-title class="mb-1">
            <feather-icon icon="SmartphoneIcon" size="21"/>
            {{ kb_question.Title }}
          </b-card-title>
          <b-card-text class="mb-2">
            Cập nhật: {{ kb_question.PublishDate }}
          </b-card-text>

          <!-- Content -->
          <!-- eslint-disable vue/no-v-html -->
          <div class="question-content" v-html="kb_question.Content"/>
          <!-- eslint-enable -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCard, BCardText, BCardTitle, BCol, BListGroup, BListGroupItem, BRow,} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BListGroup,
    BCardText,
    BCardTitle,
    BListGroupItem,
  },
  data() {
    return {
      kb_question: {},
      idNew: this.$route.params.Slug,
      dataNews: [],
    };
  },
  methods: {
    fetchInfoNew() {
      useJwt
          .post(`/news/search/${this.idNew}`, {
            columnFilters: {
              //  "CategoryID": 1
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.kb_question = response.data.result[0];
              this.getRelatedCategory(response.data.result[0]);
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    getRelatedCategory(item) {
      useJwt
          .post(`/news/search`, {
            columnFilters: {
              CategoryID: item.CategoryID,
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.dataNews = response.data.result.filter(
                  (item) => item.ID != this.$route.params.Slug
              );
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    onChoseQuestion(item) {
      window.location.reload();
    },
  },

  created() {
    this.fetchInfoNew();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
